import Quill from 'quill'
import React, { useCallback, useEffect, useState } from 'react';
import {io} from 'socket.io-client';
import { useParams } from 'react-router-dom';
import Header from './header';
import Axios from 'axios';
import { useNavigate } from 'react-router-dom';

const save_interval = 2000;
var toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],
  
    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    [{ 'direction': 'rtl' }],                         // text direction
  
    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  
    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],
  
    ['clean']                                         // remove formatting button
  ];


export default function TextEditor() {

        const [socket, setSocket] = useState(); //TODO: UseState for Socket to access it All Over
        const [quill, setQuill] = useState();
        const {id: documentId} = useParams();
        const [viewer, setViewer] = useState(false);
        const [blog, setBlog] = useState(false);

        //! To navigate for 401
        const navigate = useNavigate();

        //TODO: Checking weather the user have access to the document or not
        useEffect(async () => {
          //? 1. Document Id
          //? 2. Current User Id

          const url = `https://docsserver.onrender.com/share/check/${documentId}`;
          try
          {
            let res = await Axios.get(url);
            //console.log("🎯 Docx access");
            //console.log(res.data);
            if(res.data == "viewer")
            {
              //console.log("❌ Iam Disabling");
              setViewer(true);
              quill.disable();
            }
            else if(res.data == "Blog"){
              setViewer(true);
              setBlog(true);
              quill.disable();
            }
            else
            {
              //! Must be handled
              setViewer(false);
              setBlog(false);
              //q.disable();
            }
          }
          catch(err)
          {
            //console.log(err.response);
            if(err.response.status == 401)
            {
              //console.log("Shit");
              //console.log(err.response.data);
              navigate("/unauthorized")
            }
            else
            {
              //console.log(err);
            }
          }
          

        }, [])

        //! Creating Connection to Socket
        useEffect(() => {
          const s = io("https://docsserver.onrender.com");
          setSocket(s);
          //console.log(s);

          //? Clean Up Function
          return () => {
            s.disconnect()
          }
        }, [])
        

        //! For Creating Rooms
        useEffect(() => {
          if (socket == null || quill == null) return

          socket.once("load-document", document => {
            //console.log("Received Docx");
            //console.log("---");
            //console.log(document);
            quill.setContents(document)
            viewer?quill.disable():quill.enable()
          }, [viewer])

          socket.emit("get-document-id", documentId);
          //console.log("Sent Document ID");
          
        }, [socket, quill, documentId])

        //TODO: To Get Text Change Notification
        useEffect(() => {

          if(socket == null || quill == null) return

          const handler = (delta) => {
            quill.updateContents(delta);
          }

          socket.on('receive-changes', handler);

          return () => {
            socket.off('receive-changes', handler);
          }
        }, [socket, quill])

          //TODO: To send Text Change Notification
          useEffect(() => {

            if(socket == null || quill == null) return
  
            const handler = (delta, oldDelta, source) => {
              if(source !== 'user') return  //! We must send if only user made changes
  
              socket.emit("send-changes", delta) 
            }
  
            quill.on('text-change', handler);
  
            return () => {
              quill.off('text-change', handler);
            }
          }, [socket, quill])

          //TODO: Save Text
          useEffect(() => {

            if(socket == null || quill == null) return
  
            const interval = setInterval(() => {
              socket.emit('save-document', quill.getContents())
            }, save_interval)

            return() => {
              clearInterval(interval)
            }

          }, [socket, quill])


        //! Creating Quill Text Editor
        const wrapperRef = useCallback( wrapper => {

            if(wrapper == null) return

            wrapper.innerHTML = "";
            const editor = document.createElement("div");
            wrapper.append(editor) 
            const q = new Quill(editor, { theme: "snow", modules:{
                toolbar: viewer?"":toolbarOptions }
              })

            q.disable();
            q.setText('Loading ...')
            setQuill(q);
        }, [viewer])

        function disableTyping(e)
        {
          e.preventDefault();
        }


  return (
    <section className='editor-sec' onKeyPress={viewer? (e) => disableTyping(e) :null}>
        {blog?"":<Header documentId = {documentId} viewer={viewer}/>}
        <div className = "container z-0" ref={wrapperRef}></div>
    </section>
  )
}
